import { completaIscrizioneSchema } from '@aulaviva/shared';
import { Alert, Button, PageHeading, PasswordField } from '@aulaviva/ui';
import { zodResolver } from '@hookform/resolvers/zod';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useNavigate, useParams } from 'react-router';
import type { z } from 'zod';
import { useCompletaIscrizione, useInfoCompletaIscrizione } from '@/api/percorsi';
import { homePerRuolo } from '@/lib/ruoli';
import { auth, comuni, percorsi } from '@/testi';

type Input = z.infer<typeof completaIscrizioneSchema>;

/** Utenti importati dall'organizzatore: dal link email scelgono la password ed entrano. */
export function CompletaIscrizione() {
  const t = percorsi.completa;
  const { token = '' } = useParams();
  const navigate = useNavigate();
  const info = useInfoCompletaIscrizione(token);
  const completa = useCompletaIscrizione();
  const [errore, setErrore] = useState<string | null>(null);
  const { register, handleSubmit, formState } = useForm<Input>({ resolver: zodResolver(completaIscrizioneSchema), defaultValues: { token, password: '' } });

  if (info.isPending) return <p className="t-body text-ink-muted">{comuni.caricamento}</p>;
  if (info.isError)
    return (
      <>
        <PageHeading subtitle={t.nonValidoTesto}>{t.nonValido}</PageHeading>
        <Link to="/accedi">
          <Button variant="primary">{t.vaiAllAccesso}</Button>
        </Link>
      </>
    );

  async function invia(dati: Input) {
    setErrore(null);
    try {
      const { utente } = await completa.mutateAsync({ token, password: dati.password });
      navigate(homePerRuolo(utente.ruolo), { replace: true });
    } catch (e) {
      setErrore(e instanceof Error ? e.message : comuni.erroreGenerico);
    }
  }

  return (
    <>
      <PageHeading subtitle={t.sottotitolo(info.data.nome, info.data.percorsoTitolo)}>{t.titolo}</PageHeading>
      <form onSubmit={handleSubmit(invia)} noValidate className="flex flex-col gap-6">
        {errore && <Alert variant="error" title={errore} />}
        <input type="hidden" {...register('token')} />
        <p className="t-body text-ink-muted">
          {auth.campi.email}: <strong className="text-ink">{info.data.email}</strong>
        </p>
        <PasswordField label={auth.campi.nuovaPassword} hint={auth.campi.aiutoPassword} autoComplete="new-password" error={formState.errors.password?.message} {...register('password')} />
        <Button type="submit" variant="primary" size="lg" fullWidth loading={completa.isPending} loadingText={t.inCorso}>
          {t.azione}
        </Button>
      </form>
    </>
  );
}
